/*
* Builds the list of options for period select menus in data entry create/edit views
* @param {VueComponent} self
* @param {Boolean} isCreateView
* @return void
*/
export function buildPeriodOptionsList (self, isCreateView) {
  if (isCreateView) {
    if (self.currentPeriod && Object.keys(self.currentPeriod).length) {
      self.nonAsyncSuggestions.period.push({ label: 'Current', value: self.currentPeriod.id })
      self.form.period = self.currentPeriod.id
    }
  } else {
    if (self.currentPeriod && Object.keys(self.currentPeriod).length) {
      self.nonAsyncSuggestions.period.push({ label: 'Current', value: self.currentPeriod.id })
    }
    if (self.originalHeader.period) {
      const period = self.getPeriodById(self.originalHeader.period)
      if (period && Object.keys(period).length) {
        if (period.id !== self.currentPeriod.id) {
          let label
          if (period.start && period.end) {
            label = `${period.start} - ${period.end}`
          } else {
            label = period.start
          }
          self.nonAsyncSuggestions.period.push({ label, value: period.id })
        }
        self.form.period = period.id
      }
    } else {
      self.form.period = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/BuildPeriodOptionsList.js